var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 56C43.464 56 56 43.464 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56Z",
    fill: "#CBC9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4389 12.0248L39.34 10.9259L36.937 11.8941L38.9848 13.9419L32.6193 20.3074L25.973 13.6612L21.1371 18.4971L13.8802 11.2401L11.833 13.2873L13.5772 15.0315L11.833 16.7757V41.8534L13.1079 43.1283L11.4868 44.7495L22.1163 55.379C24.0136 55.7845 25.9815 56 27.9999 56C43.4639 56 55.9999 43.464 55.9999 28C55.9999 26.3286 55.8528 24.6916 55.5721 23.1008L42.4675 9.99622L40.4389 12.0248Z",
    fill: "#A5A3F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8154 19.4899H42.6024V43.5524H37.8154V19.4899Z",
    fill: "#95CC29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6348 25.1774H35.4218V43.5524H30.6348V25.1774Z",
    fill: "#95CC29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4546 20.693H28.2416V43.5524H23.4546V20.693Z",
    fill: "#C3E54D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2739 28.0211H21.0609V43.5524H16.2739V28.0211Z",
    fill: "#C3E54D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8804 42.3555V11.24H11.4868V42.3555V44.7491H13.8804H29.4382L30.6349 43.5523L29.4382 42.3555H13.8804Z",
    fill: "#555A65"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.438 42.3556H44.9958V44.749H29.438V42.3556Z",
    fill: "#333940"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7748 11.8622L16.4863 23.6096L17.7732 24.6271L25.9208 14.3227L29.4381 17.8244L30.157 17.2697L29.4381 15.5094L25.7748 11.8622Z",
    fill: "#555A65"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9157 12.8914L41.0284 15.6632L42.6287 13.9263L42.4677 9.99622L38.5376 10.1571L36.9373 11.894L39.7091 11.7797L33.0031 19.0584L29.4385 15.5094V17.8244L33.0542 21.4243L40.9157 12.8914Z",
    fill: "#333940"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.faa99127874ad17bcc7805f949308486.svg";
export { ForwardRef as ReactComponent };